import { WorkspaceOrder } from '@/@types/WorkspaceOrder';
import { WorkspaceViewArticleItem } from '@/@types/WorkspaceViewArticleItem';

/**
 * Article ids a workspace page may auto-open, in sidebar order (depth first): entries present in
 * the article list and not archived. The page tries them in turn, so a single article that
 * fails to load does not lock the user out of the whole workspace (SNAP-2449).
 */
export const getOpenableArticleIds = (order: WorkspaceOrder[], articles: WorkspaceViewArticleItem[]): string[] => {
  const openable = new Set(articles.filter((article) => !article.isArchived).map((article) => article.id));
  const ids: string[] = [];

  const walk = (items: WorkspaceOrder[]) => {
    items.forEach((item) => {
      if (openable.has(item.value)) ids.push(item.value);
      if (item.items?.length) walk(item.items);
    });
  };
  walk(order);

  return ids;
};

const SKIPPABLE_STATUSES = [403, 404, 422];

/**
 * Whether auto-selection may move on to the next article after this load error. Only the
 * article-specific refusals qualify; an auth, server or network failure would fail for every
 * candidate, so it stops the loop instead of firing one request per article.
 */
export const isSkippableArticleError = (error: unknown): boolean => {
  const status = (error as { response?: { status?: number } } | null)?.response?.status;
  return status !== undefined && SKIPPABLE_STATUSES.includes(status);
};
